export default __webpack_public_path__ + "fr-CA.70a6aaec.csv";